import Button from "../../../components/button/Button";
import WarningIcon from "../../../components/icons/WarningIcon";
import useTranslation from "../../../hooks/i18n/useTranslation";
import ModalBase from "../../common/uploadModal/modalBase/ModalBase";
import "./ValidationConfirmationModal.css";

const ValidationConfirmationModal = ({ onClose, onContinue, modality }) => {
  const { t } = useTranslation();
  const isDrrMode = modality === "DRR";

  return (
    <ModalBase
      title=""
      onClose={onClose}
      className="validation-confirmation-modal"
    >
      <div className="validation-confirmation-content">
        <div className="validation-confirmation-wrapper">
          <div className="validation-confirmation-header">
            <WarningIcon />
            <h2 className="validation-confirmation-title">{t("467")}</h2>
          </div>
          <div className="validation-confirmation-message App-title-widgets">
            {t("468")}
          </div>
          <div className="validation-confirmation-submessage">
            {isDrrMode ? t("470") : t("469")}
          </div>
        </div>
        <div className="validation-confirmation-actions">
          <Button value={t("471")} onClick={onContinue} />
        </div>
      </div>
    </ModalBase>
  );
};

export default ValidationConfirmationModal;
